export const defaultSchedulers = {
  '*/1 * * * *': '1 min',
  '*/30 * * * *': '30 min',
  '0 */1 * * *': '1 hr',
  '0 */2 * * *': '2 hrs',
  '0 */3 * * *': '3 hrs',
  '0 */6 * * *': '6 hrs',
  '0 */12 * * *': '12 hrs',
  '0 */24 * * *': '24 hrs'
};

export const defaultDeploymentStatus = {
  PROVISIONING: 'PROVISIONING',
  PROVISIONED: 'PROVISIONED',
  FAILED: 'FAILED',
  DELETING: 'DELETING',
  DELETED: 'DELETED'
};

export const UTCValues = [
  { name: 'UTC-12', value: -12 },
  { name: 'UTC-11', value: -11 },
  { name: 'UTC-10', value: -10 },
  { name: 'UTC-9', value: -9 },
  { name: 'UTC-8', value: -8 },
  { name: 'UTC-7', value: -7 },
  { name: 'UTC-6', value: -6 },
  { name: 'UTC-5', value: -5 },
  { name: 'UTC-4', value: -4 },
  { name: 'UTC-3', value: -3 },
  { name: 'UTC-2', value: -2 },
  { name: 'UTC-1', value: -1 },
  { name: 'UTC+0', value: 0 },
  { name: 'UTC+1', value: +1 },
  { name: 'UTC+2', value: +2 },
  { name: 'UTC+3', value: +3 },
  { name: 'UTC+4', value: +4 },
  { name: 'UTC+5', value: +5 },
  { name: 'UTC+6', value: +6 },
  { name: 'UTC+7', value: +7 },
  { name: 'UTC+8', value: +8 },
  { name: 'UTC+9', value: +9 },
  { name: 'UTC+10', value: +10 },
  { name: 'UTC+11', value: +11 },
  { name: 'UTC+12', value: +12 }
];

export const strongColors = [
  '#1e1e1e',
  '#b3b9c1',
  '#52A759',
  '#2b8162',
  '#306bf6',
  '#173475',
  '#b42dff',
  '#8a38fe',
  '#f5aa23',
  '#f43939'
];
